import type { HttpResponseSuccess, HttpResponseError } from './service';

import service from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);


export const hubspotPretrialFirstLogin = (
	signupSessionId: string,
    email: string
) => {
	return apiService.post<HttpResponseSuccess<{
		accessToken: string;
		refreshToken: string;
		user: {
			name: string;
			role: string;
			company: string;
			email: string;
		}
	}>, HttpResponseError>(`/api/user/pretrial/first-login`, {
		signupSessionId,
        email
	});
};
